<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-08-17 20:29:38
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-18 11:56:41
-->
<template>
  <router-view v-if="$windowSelf" />
</template>
<script>
// import openSocket from '@/utils/socket'
import Cookies from 'js-cookie'
import { _local } from '@/utils/storage'
import { personalPage } from '@/utils/dict'
import moment from 'moment'
export default {
  name: 'App',
  mounted() {
    const name = window.location.pathname
    const isDemo = window.location.search.includes('isDemo')
    const paths = ['/pearlgo-login', '/zhizh-login', '/gule-login', '/open-contract']
    if (!paths.includes(name) && !isDemo) {
      this.$store.dispatch('getUserAuth', true)
      this.$store.dispatch('getMerchant', true)
      this.initSocket()
      const bind = this.$store.state.user.hasBindData
      if (!bind) {
        this.$store.dispatch('getBindData')
      }
      // 获取链接参数，进入Bi的平台
      let search = window.location.search
        .substring(1, window.location.search.length)
        .split('&')
        .map(el => {
          return { key: el.split('=')[0], value: el.split('=')[1] }
        })
      let query = {}
      search.forEach(el => (query[el.key] = el.value))
      this.$store.dispatch('buried', {
        event: 'enterTheBI',
        otherInfo: { fromPlatform: query.fromPlatform },
        enterTime: moment(Date.now()).format('YYYY-MM-DD HH:MM:SS'),
      })
    }
  },
  created() {
    this.buildIframe()
  },

  methods: {
    initSocket() {
      this.$store.dispatch('getNoticeList')
      this.$store.dispatch('getMessageList')
      const pathName = window.location.pathname
      // TODO: 个人中心跳过
      if (!personalPage.includes(pathName)) {
        this.$store.dispatch('checkWebHook')
      }
      // openSocket(process.env.VUE_APP_SOCKET)
    },
    buildIframe() {
      if (this.$windowSelf) {
        setTimeout(() => {
          const iframe = document.createElement('iframe')
          const token = _local.get('saasToken') || Cookies.get('saasToken')
          const name = _local.get('userName')
          const url = `${_local.get('BITOSHOPLINK') || process.env.VUE_APP_SHOP_URL}?name=${name}&token=${token}`
          iframe.src = url
          iframe.style.display = 'none'
          document.querySelector('body').appendChild(iframe)
          iframe.onload = () => {
            this.$store.commit('user.onloadIframe', true)
          }
        }, 300)
      }
    },
  },
}
</script>
